import { computed } from "vue";
import { v4 as uuidV4 } from "uuid";
import qs from "qs";
import DeviceServices from "@/services/DeviceServices";

/**
 * 開啟連結
 * @param url 網址
 * @param open 是否另開分頁，預設false
 */
export const openLink = ({
  url,
  open = false,
}: {
  url: string;
  open?: boolean;
}) => {
  if (open) {
    window.open(url);
  } else {
    window.location.href = url;
  }
};

/**
 * 組登入網址
 *
 * @param url 轉回的頁面,預設活動首頁
 * @returns
 */
export const loginUrl = ({ url = import.meta.env.VITE_BASE, isComics = true }: { url?: string, isComics?: boolean }) => {
  console.log("login redirect -------:", url);
  if (import.meta.env.SERVER) {
    return "";
  }
  const isMobile = ["iOS", "iPadOS", "AndroidOS", "WindowsPhoneOS"].includes(
    DeviceServices.getDevice()
  );

  // 設定轉址
  sessionStorage.setItem(
    "loginRedirect",
    JSON.stringify({
      name: "redirect",
      params: {},
      query: {},
    })
  );

  // 轉址目標
  sessionStorage.setItem("eventLoginRedirect", url);
  let query = qs.stringify({
    response_type: "code",
    // prompt: 'select_account',
    prompt: isMobile ? "password" : "qrcode",
    user_level: "5",
    client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
    scope: "openid profile",
    redirect_uri: import.meta.env.VITE_COMICS_URL + "/login",
    state: uuidV4(),
    nonce: uuidV4(),
    event: "true",
  });

  // 漫畫星語文學星登入的key不一樣!
  if(!isComics){
    query = qs.stringify({
      response_type: "code",
      // prompt: 'select_account',
      prompt: isMobile ? "password" : "qrcode",
      user_level: "5",
      client_id: import.meta.env.VITE_NOVELS_OAUTH_CLIENT_ID,
      scope: "openid profile",
      redirect_uri: import.meta.env.VITE_NOVELS_URL + "/login",
      state: uuidV4(),
      nonce: uuidV4(),
      event: "true",
    });
  }


  return `${import.meta.env.VITE_OAUTH_URL}?${query}`;
  // });
};
